import React from 'react';
import { BudgetTemplateLine } from 'loot-core/src/shared/budget-template';
import { InputCell } from '../../table';
import { amountToInteger, integerToCurrency } from 'loot-core/src/shared/util';
import { CSSProperties, theme } from '../../../style';
import { CellEditing } from '../types';
import { makeAmountGrey } from '../../budget/util';
import { evalArithmetic } from 'loot-core/shared/arithmetic';

export interface IAmountInputProps {
  budgetLine: Partial<BudgetTemplateLine>;
  editing: boolean;
  onEditCell: (cell: CellEditing) => void;
  onChange: (amount: number) => void;
  style?: CSSProperties;
}

function commitAmount(value: string, onChange: (amount: number) => void) {
  onChange(value === '' ? 0 : amountToInteger(evalArithmetic(value, 0)));
}

export default function AmountInput({ budgetLine, editing, onEditCell, onChange, style = {} }: IAmountInputProps) {
  return (
    <InputCell
      value={budgetLine.amount === null ? '' : integerToCurrency(budgetLine.amount)}
      // formatter={value => displayed}
      width="flex"
      exposed={editing}
      focused={editing}
      onExpose={() => onEditCell({ id: budgetLine.category, column: 'amount' })}
      onUpdate={value => {
        commitAmount(value, onChange);
      }}
      onBlur={event => {
        commitAmount(event.currentTarget.value, onChange);
        onEditCell(null);
      }}
      style={{ borderTopWidth: 0, borderBottomWidth: 0 }}
      textAlign="right"
      inputProps={{
        style: {
          marginLeft: 20,
          cursor: 'default',
          padding: '6px 4px',
          borderWidth: 0,
          borderRadius: 4,
          ':hover': {
            borderWidth: 1,
            boxShadow: 'inset 0 0 0 1px ' + theme.mobileAccountShadow,
            backgroundColor: theme.tableBackground,
          },
          textAlign: 'right'
        }
      }}
      valueStyle={{
        cursor: 'default',
        margin: 1,
        padding: '0 4px',
        borderRadius: 4,
        ':hover': {
          boxShadow: 'inset 0 0 0 1px ' + theme.mobileAccountShadow,
          backgroundColor: theme.tableBackground,
        },
        ...makeAmountGrey(budgetLine.amount),
        ...style
      }}
      privacyFilter={true}
    />
  );
}
